import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Button, CardContent, Container, FormControl, Grid, InputLabel, MenuItem, Select, Typography, useMediaQuery } from '@mui/material';
import { gridSpacing } from '../../constant/Constants';
import HistoryIcon from '@mui/icons-material/History';
import PopularHistory from '../../layouts/ui-component/cards/card-content/PopularHistory';
import MainCard from '../../layouts/ui-component/cards/MainCard';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import PaginationHistory from './PaginationHistory';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ReplayIcon from '@mui/icons-material/Replay';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../redux/create-actions/AlertAction';
import { formatDate } from '../../utils/function/Function'
import { closeLoadingApi, openLoadingApi } from '../../redux/create-actions/LoadingAction';
import FontSize from '../../layouts/FontSize';
import Color from '../../layouts/Color';
import { graphGetAllContractByCustomer } from '../../services/Contract';
import { transactionHistory } from '../../services/Transaction';
import dayjs from 'dayjs';

// ==============================||  Transaction History ||============================== //

const paddingStyle = { mb: 2 };
const actionStyle = {
    textAlign: 'end',
    paddingTop: 'inherit'
};
const applyStyle = {
    bgcolor: Color.Main,
    color: Color.Button
};
const filterStyle = {
    color: Color.Main
};
const container = { mt: 3 };

const TransactionHistory = ({ isLoading }) => {
    const theme = useTheme();
    var followingDay = new Date(new Date().getTime() - 86400000 * 7);

    const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
    const [fromDate, setFromDate] = useState(formatDate(followingDay));
    const [toDate, setToDate] = useState(formatDate(new Date()));
    const [contracts, setContracts] = useState(null);
    const [cardNumber, setCardNumber] = useState(0);
    const [showFilter, setShowFilter] = useState(0);
    const [history, setHistory] = useState(null);

    const dispatch = useDispatch();

    useEffect(() => {
        let alert = {
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center'
            },
            isOpen: true,
            severity: 'error',
            title: 'Error',
            message: ''
        };
        dispatch(openLoadingApi());
        const promise = graphGetAllContractByCustomer();
        promise.then((result) => {
            setCardNumber((result.items)[0].id);
            setContracts(result.items);
        }).catch(error => {
            const err = JSON.parse(JSON.stringify(error))
            alert = { ...alert, message: err.response.errors[0].message };
            dispatch(showAlert(alert));
            dispatch(closeLoadingApi());
        })
    }, [dispatch])

    useEffect(() => {
        if (cardNumber !== 0) {
            dispatch(openLoadingApi());
            const data = {
                contractId: parseInt(cardNumber),
                fromDate: fromDate,
                toDate: toDate
            }
            let transactionsHistory = transactionHistory(data);
            transactionsHistory
                .then(result => {
                    setHistory(result.data.TransactionList)
                    dispatch(closeLoadingApi());
                }).catch(function (error) {
                    const err = JSON.parse(JSON.stringify(error));
                    console.log(err);
                    dispatch(closeLoadingApi());
                })
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cardNumber])

    const handleClick = () => {
        setShowFilter(showFilter + 1);
    };

    const handleReload = () => {
        let alert = {
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center'
            },
            isOpen: true,
            severity: 'error',
            title: 'Error',
            message: '',
        };
        if (cardNumber !== null && fromDate !== null && toDate !== null) {
            dispatch(openLoadingApi());
            const data = {
                contractId: parseInt(cardNumber),
                fromDate: fromDate,
                toDate: toDate
            }
            let transactionsHistory = transactionHistory(data);
            transactionsHistory
                .then(result => {
                    setHistory(result.data.TransactionList)
                    dispatch(closeLoadingApi());
                }).catch(function (error) {
                    const err = JSON.parse(JSON.stringify(error));
                    console.log(err);
                    dispatch(closeLoadingApi());
                })
        }
        else {
            alert = { ...alert, message: "Please enter all the information!" };
            dispatch(showAlert(alert));
        }
    };

    const handleChange = (event) => {
        setCardNumber(event.target.value);
    };
    const displayCardNumber =
        contracts?.map((contract) => {
            return (
                <MenuItem key={contract.id} id={contract.id} value={contract.id}>
                    {(contract.contractNumber).slice(0, 4) + "    " + (contract.contractNumber).slice(4, 8).replace("__", "**") + "    " + (contract.contractNumber).slice(8, 12).replace("____", "****") + "    " + (contract.contractNumber).slice(12, 16)}
                </MenuItem>
            )
        })

    const renderFilter = () => {
        return (showFilter % 2 === 0 && contracts !== null) ? (
            <React.Fragment>
                <Grid item xs={0} sm={12} md={6} xl={8}></Grid>
                <Grid item xs={12} sm={12} md={6} xl={4}>
                    <Grid container
                        alignItems="center"
                        sx={paddingStyle}
                    >
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <InputLabel id="cardnumber-filter"> CardNumber </InputLabel>
                                <Select
                                    labelId="cardnumberl-filter"
                                    id="demo-simple-select-helper"
                                    value={cardNumber}
                                    label="CardNumber"
                                    onChange={handleChange}
                                    size="medium"
                                    sx={{
                                        '& .MuiInputBase-input': {
                                            bgcolor: theme.palette.background.default
                                        },
                                        bgcolor: theme.palette.background.default,
                                    }}
                                >
                                    {displayCardNumber}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        alignItems="center"
                        spacing={2}
                    >
                        <Grid item xs={12} sm={6} md={6}>
                            <FormControl fullWidth>
                                <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                >
                                    <DemoContainer components={['DatePicker']}>
                                        <DatePicker
                                            disableFuture
                                            label="Date from(MM/DD/YYYY)"
                                            size="small"
                                            openTo="year"
                                            views={['year', 'month', 'day']}
                                            // minDate={new Date('2018-03-01')}
                                            // maxDate={new Date('2030-06-01')}
                                            value={dayjs(fromDate)}
                                            onChange={(newFromDate) =>
                                                setFromDate(dayjs(newFromDate).format('YYYY-MM-DD'))
                                            }
                                            sx={{
                                                '& .MuiInputBase-input': {
                                                    bgcolor: theme.palette.background.default
                                                },
                                                '& .MuiOutlinedInput-root': {
                                                    bgcolor: theme.palette.background.default
                                                },
                                            }}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <FormControl fullWidth>
                                <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                >
                                    <DemoContainer components={['DatePicker']}>
                                        <DatePicker
                                            disableFuture
                                            label="Date to(MM/DD/YYYY)"
                                            size="small"
                                            openTo="year"
                                            views={['year', 'month', 'day']}
                                            // minDate={new Date('2018-03-01')}
                                            // maxDate={new Date('2030-06-01')}
                                            value={dayjs(toDate)}
                                            onChange={(newToDate) =>
                                                setToDate(dayjs(newToDate).format('YYYY-MM-DD'))
                                            }
                                            sx={{
                                                '& .MuiInputBase-input': {
                                                    bgcolor: theme.palette.background.default
                                                },
                                                '& .MuiOutlinedInput-root': {
                                                    bgcolor: theme.palette.background.default
                                                },
                                            }}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid sx={actionStyle}>
                        <Button
                            variant='contained'
                            onClick={handleReload}
                            endIcon={<ReplayIcon />}
                            sx={applyStyle}
                        > Apply
                        </Button>
                    </Grid>
                </Grid>
            </React.Fragment>
        ) : (<React.Fragment></React.Fragment>)
    }

    return (
        <>
            {isLoading ? (
                <PopularHistory />
            ) : (
                <Container maxWidth="xl" sx={container}>
                    <MainCard content={false}>
                        <CardContent
                            sx={{
                                p: `${matchDownSM ? '12px' : '40px'}`,
                                pt: `${matchDownSM ? '20px' : '40px'}`
                            }}
                        >
                            <Grid container spacing={gridSpacing}  >
                                <Grid container
                                    alignItems="center"
                                    justifyContent="space-between"
                                    sx={{
                                        p: `${matchDownSM ? '20px 20px  5px  20px' : '24px'}`,

                                    }}
                                >
                                    <Grid item   >
                                        <Button endIcon={<HistoryIcon />} sx={{ color: theme.typography.h3, cursor: 'default', fontSize: FontSize.Normal }}>
                                            Transaction History
                                        </Button>
                                    </Grid>
                                    <Grid item
                                    >
                                        <Typography variant="h3">
                                            <Button
                                                style={filterStyle}
                                                id="demo-positioned-button"
                                                aria-controls={showFilter ? 'demo-positioned-menu' : undefined}
                                                aria-haspopup="true"
                                                aria-expanded={showFilter ? 'true' : undefined}
                                                onClick={handleClick}
                                                endIcon={<FilterAltIcon />}
                                            >
                                                Filter
                                            </Button>
                                        </Typography>
                                    </Grid>
                                </Grid>
                                {renderFilter()}
                                <Grid item xs={12}>
                                    <PaginationHistory center={true} historyReload={history} />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </MainCard>
                </Container>
            )}
        </>
    );
};

TransactionHistory.propTypes = {
    isLoading: PropTypes.bool
};

export default TransactionHistory;
